import React from "react";
import i18n from "i18n";

const defaultSelectOptions = [
  "daily",
  "weekly",
  "monthly",
  "perYear",
  "threeYears",
];

export const defaultOptions = (
  <>
    <option disabled value="">
      {i18n.t("chooseDate")}
    </option>
    {defaultSelectOptions.map((option) => (
      <option key={option} value={option}>
        {i18n.t(option)}
      </option>
    ))}
  </>
);
